export enum VisibilityState {
    Visible = 'visible',
    Hidden = 'hidden'
  }